import OneVacancy from "./OneVacancy/index";
import LoadedComponent from "./LoadedComponent/index";
import { useEffect } from "react";
import "./allvacancies.scss";
import { inject, observer } from "mobx-react";

const AllVacancies = ({
  token,
  vacancies,
  allVacanciesCount,
  positions,
  cities,
  getVacanciesData,
  showMoreVacancies,
  error,
  isLoading,

  setSignInModal
}) => {
  useEffect(() => {
    !token && setSignInModal(true);
    getVacanciesData();
  }, []);

  return (
    <div className="allvacancies-wrapper">
      <div className="cards-map">
        <LoadedComponent isLoading={isLoading} error={error}>
          <div className="cards-map__cards">
            {vacancies.length > 0 &&
              vacancies.map((vacancy) => {
                if (positions[vacancy["position_id"]])
                  return (
                    <OneVacancy
                      position={
                        positions[vacancy["position_id"]]["title"].split(
                          / (\d)/
                        )[0]
                      }
                      date={vacancy.date_update}
                      description={vacancy.description}
                      salary={vacancy.wages.replace(
                        /(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g,
                        "$1" + " "
                      )}
                      // Вознаграждение скрыто в задаче FRONT-843
                      // agentSalary={vacancy.agent_wages.replace(
                      //   /(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g,
                      //   "$1" + " "
                      // )}
                      worklocation={cities[vacancy.city_id]["title"]}
                      hot={vacancy.fire}
                      setSignInModal={setSignInModal}
                      id={vacancy.id}
                      key={vacancy.id}
                    />
                  );
              })}
          </div>
          <button
            onClick={() => {
              showMoreVacancies();
            }}
            disabled={!token || vacancies.length == allVacanciesCount}
            className="cards-map-button"
          >
            Показать еще
          </button>
        </LoadedComponent>
      </div>
    </div>
  );
};

export default inject(({ usersStore, modalWindows, vacanciesStore }) => {
  const { token } = usersStore;
  const { setSignInModal } = modalWindows;
  const {
    vacancies,
    allVacanciesCount,
    getVacanciesData,
    showMoreVacancies,
    positions,
    cities,
    error,
    isLoading
  } = vacanciesStore;

  return {
    token,
    setSignInModal,
    vacancies,
    allVacanciesCount,
    positions,
    cities,
    getVacanciesData,
    showMoreVacancies,
    error,
    isLoading
  };
})(observer(AllVacancies));
